import {
  Alert,
  AlertDescription,
  // AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  Text,
} from "@chakra-ui/react";
import { ErrorType } from "../../app/index";

interface CodeAlertProps {
  isOpen: boolean;
  error: ErrorType | undefined;
  onClose?: () => void;
}

export const CodeAlert = ({ isOpen, error, onClose }: CodeAlertProps) => {
  return (
    <>
      {isOpen && (
        <Alert
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="md"
          width="2xl"
          borderRadius="15px"
          bgColor={process.env.REACT_APP_PARTNER_SECONDARY}
          color={process.env.REACT_APP_PARTNER_PRIMARY}
          status={error?.status ? "error" : "success"}
        >
          <AlertIcon boxSize="10" color={process.env.REACT_APP_PARTNER_PRIMARY} />
          <Box>
            <AlertTitle color={process.env.REACT_APP_PARTNER_PRIMARY} mr={2} mt="1em">
              {error?.msg}
            </AlertTitle>
            <AlertDescription color={process.env.REACT_APP_PARTNER_PRIMARY}>
              Riprovare ad effettuare l'accesso.
            </AlertDescription>
            <Text fontSize={"0.7em"}>v. {process.env.REACT_APP_VERSION}</Text>
          </Box>

          <CloseButton
            size="md"
            color="wishlist.500"
            onClick={onClose}
            position="absolute"
            right="8px"
            top="8px"
          />
        </Alert>
      )}
    </>
  );
};
